module.exports = __webpack_public_path__ + "media/bootstrap-icons/life-preserver-a4fa2a6f.svg";